/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  // Add custom code below this line
  window.customClosePswp = () => {
    const closeBtn = document.querySelector('.pswp__custom-close');
    if (closeBtn) closeBtn.click();
  }
  
  window.openShopifyCustomerCookiePrefs = () => {
	if(window.privacyBanner != undefined){
		window.privacyBanner.showPreferences();
	}
  }

	window.getCookieByName = (name) => (
		document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''
	)

  const handleMarketChange = (event) => {
		event.preventDefault();
		const selectedOption = event.currentTarget;

		const form = selectedOption.closest(".form--localization");
		const popoutSelect = form.querySelector(".popout--country");

		// Get form inputs
		const input = popoutSelect.querySelector("[data-popout-input]");
		const redirectInput = popoutSelect.querySelector("[data-popout-redirect]");
		const attrValue = selectedOption.hasAttribute("data-value") ? selectedOption.getAttribute("data-value") : "";
		input.value = attrValue;

		// Avoid displaying the preview bar in production
		const previewtheme = window.Shopify.theme.role === "unpublished" ? `&preview_theme_id=${Shopify.theme.id}`: ''; 
		// Specify the theme preview
		redirectInput.value = `${redirectInput.value}${previewtheme}`;

		// Change market and domain
		form.submit();
	};

	// Function to perform a market redirection when the current market is not enabled
	function redirectMarketIfRequired() {
		// select a market to redirect to from the market selector
		const marketRedirectRequired = document.querySelector("#popout-list__option--market-redirect");
		if(marketRedirectRequired) {
			marketRedirectRequired.addEventListener("click", handleMarketChange);
			marketRedirectRequired.click();
		}
	}
	redirectMarketIfRequired();


	/* Save user way widget original position on init */
	document.addEventListener('userway:init_completed', function (event) {
		const userwayPosition = window.UserWayWidgetApp?.ContextHolder?.config?.tunings?.widget_position;
		if(userwayPosition){
			window.UserWayOriginalPosition = userwayPosition;
		}
  	})

	/* Move user way widget position on render if necessary */
	document.addEventListener('userway:render_completed', function (event) {
	if(window.UserWay != undefined && window.customDrawerIsOpen){
          window.UserWay.setPosition(3)
      }
	})
	/* Move user way widget position on drawer open */
	document.addEventListener("theme:drawer:open", ()=> {
		window.customDrawerIsOpen = true;
        if(window.UserWay != undefined){
            window.UserWay.setPosition(3)
        }
	});

	/* Move user way widget position on drawer close */
	document.addEventListener("theme:drawer:close", ()=> {
		window.customDrawerIsOpen = false;
        if(window.UserWay != undefined){
          let position = 5;
          if(window.UserWayOriginalPosition != null){
            position = parseInt(Window.UserWayOriginalPosition);
          }
          window.UserWay.setPosition(position);
        }
	});

	window.loadScriptAfterInteraction = (scriptUrl, attributes = {})  =>{
		function loadScript() {
			var script = document.createElement('script');
			script.src = scriptUrl;
			script.defer = true;
			script.async = true;
			for (var key in attributes) {
				if (attributes.hasOwnProperty(key)) {
					script.setAttribute(key, attributes[key]);
				}
			}
			document.body.appendChild(script);
		}
	
		document.addEventListener('click', loadScript, { once: true });
		document.addEventListener('scroll', loadScript, { once: true });
	}


	// ======== ACCESSIBILITY: Hide hidden iframes from screen readers ========
	// This code uses a MutationObserver to monitor the DOM for dynamically added iframes.
	// If an iframe is detected and it is hidden (display: none), it adds aria-hidden="true" to it.
	// This prevents screen readers from announcing hidden iframes, improving accessibility.

	function hideIframeForAccessibility(iframe) {
		const style = window.getComputedStyle(iframe);
		if (style.display === 'none') {
			iframe.setAttribute('aria-hidden', 'true');
		}
	}

	const observer = new MutationObserver(function(mutations) {
		mutations.forEach(function(mutation) {
			mutation.addedNodes.forEach(function(node) {
				// Only process iframe elements
				if (node.tagName === 'IFRAME') {
					hideIframeForAccessibility(node);
				}
				
				// Also check if iframes are nested inside added nodes
				if (node.querySelectorAll) {
					node.querySelectorAll('iframe').forEach(hideIframeForAccessibility);
				}
			});
		});
	});
	// Observe the entire body for dynamically added iframes
	observer.observe(document.body, { childList: true, subtree: true });
	document.querySelectorAll('iframe').forEach(hideIframeForAccessibility);
	// ========= END ACCESSIBILITY ============

	// ========= ACCESSIBILITY: Make the component shop the look accessible ============
	// This code makes the "shop the look" component accessible by the keyboard and screen readers.
	// It ensures that when a modal is opened, focus is trapped within the modal, and when closed, focus returns to the last focused element. 
	document.querySelectorAll('.look__dot__button, .look__close').forEach(label => {
		label.addEventListener('keydown', e => {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				label.click();
			}
		});
	});

	// Trap focus within the modal when it's open
	document.querySelectorAll('.look_popup__input').forEach(input => {
		const modalId = input.getAttribute('data-modalid');
		if (!modalId) return;
		const modal = document.getElementById(modalId);
		if (!modal) return;

		const closeBtn = modal.querySelector('.look_popup__close');
		let lastFocusedElement = document.activeElement;

		input.addEventListener('change', () => {
			const isOpen = input.checked;
			if (isOpen) {
				lastFocusedElement = document.activeElement;
				document.addEventListener('focusin', keepFocusInside);
			} else {
				document.removeEventListener('focusin', keepFocusInside); 
				lastFocusedElement.focus();
			}
		});

		function keepFocusInside(e) {
			if (!modal.contains(e.target)) {
			e.stopPropagation();
			closeBtn.focus();
			}
		}
	});
	// ========= END ACCESSIBILITY ============


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
